<template>
  <div class="fd_body" v-if="body_show" :style="{height: bh + 'px'}">
    <div class="swiper-container gallery-top">
      <div class="swiper-wrapper">
        <div class="swiper-slide" v-for="(item,index) in imgElList" :key="index">
          <div class="crve">
            <img :src="item.img">
            <p v-html="item.describe"></p>
          </div>
        </div>
      </div>
      <!-- Add Arrows -->
      <div class="swiper-button-next swiper-button-white"></div>
      <div class="swiper-button-prev swiper-button-white"></div>
    </div>
    <div class="sa_bottom clearfix">
      <div class="sa_l" v-if="type==0">
        <img src="@a/sha8.png" alt="" @click="share_show=true" />
      </div>
      <div class="swiper-container gallery-thumbs" :style="{'float':type==0?'right':'left'}">
        <div class="swiper-wrapper">
          <div class="swiper-slide" v-for="(item,index) in imgElList" :key="index">
            <img :src="item.img">
            <!-- <h2 class="text-ellipsis">{{item.name}}</h2> -->
            <div class="spo">
              <img src="@a/sha9.png" alt="" />
            </div>
          </div>
        </div>
      </div>
    </div>
    <router-link class="feedback" :to="{path:'/invitation_progress',query:{course_id:$route.query.course_id}}">个人中心</router-link>
    <van-popup v-model="share_show" position="bottom">
      <div class="invite">
        <h2>邀请语<span @click="add_invite">换一个</span></h2>
        <p v-html="invite_text.replace(/\n/g, '<br/>')"></p>
        <a class="into_project" v-clipboard:copy="invite_text" v-clipboard:success="onCopy" v-clipboard:error="onError">
          复制邀请语
        </a>
      </div>
    </van-popup>
  </div>
</template>
<script>
import {
  getInviteWord,
  getPosters
} from "@/api/training"
import {
  shareCon
} from "@/utils/wxconfig";
import image from "@a/load_img.png";
export default {
  data() {
      return {
        body_show: false,
        galleryTop: null,
        course_id: '',
        galleryThumbs: null,
        imgData: [],
        share_show: false,
        invite_text: "",
        data: {},
        num: 0,
        imgElList: [],
        bh: 0
      }
    },
    methods: {
      loadImg() {
        let len = this.imgData.length;
        for (let i = 0; i < len; i++) {
          let img = new Image();
          img.src = this.imgData[i].img;
          img.onload = () => {
            this.imgElList[i].img = this.imgData[i].img;
            this.imgElList[i].name = this.imgData[i].name;
            this.imgElList[i].describe = this.imgData[i].describe;
          }
        }
      },
      pullData() {
        this.course_id = this.$route.query.course_id;
        this.type = this.$route.query.type;
        document.title = this.$route.query.type==100?"发展下级":"海报分享";
        let p1 = getInviteWord({
          course_id: this.course_id
        });
        let p2 = getPosters({
          course_id: this.course_id,
          type: this.type
        });
        let promise = Promise.all([p1, p2]);
        promise
          .then((DL) => {
            this.$toast.loading({
              mask: true,
              message: "加载中...",
              duration: 0
            });

            this.words = DL[0].list;
            this.imgData = DL[1].list;

            for(let i = 0; i < this.imgData.length; i++) {
              this.imgElList.push({img:image,name:'加载中',describe:'海报加载中...'});
            }

            this.body_show = true;
            this.$nextTick(() => {
              this.imgload();
              this.$toast.clear();
            });

            this.loadImg();
            this.make_invite();
            shareCon("training", this);
          })
      },
      make_invite() {
        this.invite_text = this.words[this.num].describe;
      },
      add_invite() {
        this.num = this.num < this.words.length - 1 ? this.num + 1 : 0;
        this.make_invite();
      },
      // 复制成功
      onCopy(e) {
        this.$toast('复制成功!');
      },
      // 复制失败
      onError(e) {
        alert("失败");
      },
      imgload() {
        setTimeout(() => {
          this.galleryThumbs = null
          this.galleryThumbs = new Swiper('.gallery-thumbs', {
            spaceBetween: 10,
            slidesPerView: 4.5,
            freeMode: true,
            watchSlidesVisibility: true,
            watchSlidesProgress: true,
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: false, //修改swiper的父元素时，自动初始化swiper
            onSlideChangeEnd: function(swiper) {　　　
              swiper.update();　　　
              galleryThumbs.reLoop();
            }
          });
          this.galleryTop = null;
          this.galleryTop = new Swiper('.gallery-top', {
            spaceBetween: 0,
            slidesPerView: 1,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
            thumbs: {
              swiper: this.galleryThumbs
            },
            observer: true, //修改swiper自己或子元素时，自动初始化swiper
            observeParents: false, //修改swiper的父元素时，自动初始化swiper
            onSlideChangeEnd: function(swiper) {　　　
              swiper.update();　　　
              galleryTop.reLoop();
            }
          });
        }, 100);
        this.bh = document.documentElement.clientHeight;
      }
    },
    created() {
      this.pullData();
    },
    mounted() {
      window.vm = this;
      // this.imgload()
    }
}
</script>
<style lang="scss" scoped>
.fd_body {
  display: flex;
  flex-direction: column;
}

.swiper-container {
  width: 100%;
  margin-left: auto;
  margin-right: auto;
}

.swiper-slide {
  background-size: cover;
  background-position: center;
  img {
    width: 100%;
  }
}

.gallery-top {
  height: auto;
  flex: 1;
  width: 100%;
  background-color: #333;
  text-align: center;
  padding: 40px 0;
  .swiper-slide {
    .crve {
      transform: translate(-50%, -50%);
      top: 50%;
      position: absolute;
      left: 50%;
      img {
        width: 436px;
      }
      p {
        font-size: 24px;
        line-height: 36px;
        color: #fff;
        margin-top: 20px;
      }
    }
  }
}

.gallery-thumbs {
  height: auto;
  box-sizing: border-box;
  width: 530px;
  float: right;
  border-radius: 16px 0px 0px 16px;
  margin-left: 40px;
}

.gallery-thumbs .swiper-slide {
  width: 100%;
  height: 152px;
  h2 {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    text-align: center;
    line-height: 32px;
    background-color: #F57F17;
    font-size: 20px;
    color: #fff;
    z-index: 1;
  }
  .spo {
    background: rgba(0, 0, 0, 1);
    opacity: 0.5;
    text-align: center;
    position: absolute;
    z-index: 2;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    display: none;
    img {
      width: 60px;
      margin-top: 40px;
    }
  }
}

.gallery-thumbs .swiper-slide-thumb-active {
  .spo {
    display: block;
  }
}

.sa_bottom {
  margin: 40px 0;
  .sa_l {
    padding-right: 25px;
    border-right: 2px solid #ccc;
    display: inline-block;
    float: left;
    padding-left: 30px;
    img {
      width: 118px;
    }
  }
}

.invite {
  text-align: center;
  width: 100%;
  h2 {
    font-size: 34px;
    color: #333;
    font-weight: bold;
    padding: 30px 0;
    position: relative;
    span {
      font-size: 22px;
      color: #F57F17;
      vertical-align: middle;
      position: absolute;
      top: 40px;
      right: 30px;
      font-weight: normal;
    }
  }
  p {
    line-height: 40px;
    color: #333;
    font-size: 26px;
    text-align: justify;
    padding: 0 30px;
    height: 260px;
  }
}

a.into_project {
  display: block;
  width: 100%;
  line-height: 98px;
  background: rgba(235, 80, 50, 1);
  text-align: center;
  color: #fff;
  margin-top: 40px;
  font-size: 34px;
}

.swiper-button-next,
.swiper-button-prev {
  width: 27px;
  height: 44px;
  background-size: 27px 44px;
}
.feedback{
    background-color: #ffffff;
    font-size: 24px;
    color: #333333;
    text-align: center;
    position: fixed;
    right: 0;
    bottom: 240px;
    box-shadow:0px 5px 7px 0px rgba(99,99,99,0.1);
    border-radius:35px 0px 0px 35px;
    padding: 24px 20px 24px 36px;
    z-index: 10;
}
</style>
